import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { confirmFirstPurchase } from "./thunks/confirm-first-purchase";
import { getBenefit } from "./thunks/get-benefit";
import { getRefund } from "./thunks/get-refund";
import { notifyBenefit } from "./thunks/notify-benefit";
import { unnotifyBenefit } from "./thunks/unnotify-benefit";

const name = "firstPurchase";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRefund.fulfilled, (state, action) => {
        state.refund = action.payload;
      })
      .addCase(getBenefit.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(getBenefit.fulfilled, (state, action) => {
        state.benefit = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(getBenefit.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(notifyBenefit.fulfilled, (state, action) => {
        state.benefit = action.payload;
      })
      .addCase(unnotifyBenefit.fulfilled, (state) => {
        state.benefit = { notified: false };
      })
      .addCase(confirmFirstPurchase.pending, (state) => {
        state.isConfirming = true;
        state.confirmError = "";
      })
      .addCase(confirmFirstPurchase.fulfilled, (state) => {
        state.isConfirming = false;
        state.isConfirmed = true;
      })
      .addCase(confirmFirstPurchase.rejected, (state, action) => {
        state.isConfirming = false;
        state.confirmError = action.error.message ?? "";
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
